"use strict";
/*
 * Created on 27. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *
 * @author Stepan Mik
 */

var ProgressMonitor =
/*#__PURE__*/
function () {
  function ProgressMonitor() {
    _classCallCheck(this, ProgressMonitor);
  }

  _createClass(ProgressMonitor, [{
    key: "createSubmonitor",

    /**
     * Following is true about submonitor:
     *    - if main monitor is canceled then submonitor is canceled
     *    - calling `confirmCanceled` has no effect on main monitor
     *    - failing submonitor also fails main monitor
     *    - finishing submonitor just sets main monitors progress to `target`
     * @param target
     */
    value: function createSubmonitor(target) {
      return new SubMonitor(this, target, this.cancellable);
    }
    /**
     * Created simple monitor (not backed up by database) and cancellation object for that monitor.
     */

  }], [{
    key: "simpleMonitor",
    value: function simpleMonitor() {
      var ret = new SimpleMonitor();
      return [ret, ret];
    }
    /**
     * Creates simple monitor that call provided log callback when monitor changes its state.
     * @param log
     */

  }, {
    key: "loggingMonitor",
    value: function loggingMonitor(log) {
      var ret = new LoggingMonitor(log);
      return [ret, ret];
    }
  }, {
    key: "statusToString",
    value: function statusToString(status) {
      switch (status.tag) {
        case 'working':
          return status.worked + '/' + status.total;

        case 'new':
          return 'new';
          break;

        case 'done':
          return 'done';
          break;

        case 'canceled':
          return 'canceled';

        case 'failed':
          return 'failed: ' + status.error.message;

        default:
          return JSON.stringify(status);
      }
    }
    /**
     * Creates logging monitor that logs into console.
     * @param name monitor name printed to console
     */

  }, {
    key: "consoleMonitor",
    value: function consoleMonitor(name) {
      function log(status) {
        console.log(name + ':' + ProgressMonitor.statusToString(status));
      }

      var ret = new LoggingMonitor(log);
      return [ret, ret];
    }
  }]);

  return ProgressMonitor;
}();

exports.ProgressMonitor = ProgressMonitor; //tslint:disable:max-classes-per-file

var Monitor =
/*#__PURE__*/
function (_ProgressMonitor) {
  _inherits(Monitor, _ProgressMonitor);

  function Monitor() {
    var _this;

    _classCallCheck(this, Monitor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Monitor).apply(this, arguments));
    _this._status = {
      tag: 'new'
    };
    _this.total = 0;
    _this.worked = 0;
    return _this;
  }

  _createClass(Monitor, [{
    key: "fail",
    value: function fail(err) {
      if (this.status.tag !== 'working' && this.status.tag !== 'new' && this.status.tag !== 'failed') {
        return Promise.reject(new Error('Monitor can not be failed in state ' + this.status.tag));
      }

      this._status = {
        tag: 'failed',
        error: {
          message: err.message,
          stack: err.stack ? err.stack : ''
        },
        total: this.total
      };
      return Promise.resolve();
    }
  }, {
    key: "confirmCanceled",
    value: function confirmCanceled() {
      if (this.status.tag !== 'working' && this.status.tag !== 'new' && this.status.tag !== 'canceled') {
        return Promise.reject(new Error('Monitor can not be canceled in state ' + this.status.tag));
      }

      this._status = {
        tag: 'canceled',
        total: this.total
      };
      return Promise.resolve();
    }
  }, {
    key: "finish",
    value: function finish() {
      if (this.status.tag !== 'working' && this.status.tag !== 'new' && this.status.tag !== 'done') {
        return Promise.reject(new Error('Monitor can not be finished in state ' + this.status.tag));
      }

      this._status = {
        tag: 'done',
        total: this.total
      };
      return Promise.resolve();
    }
  }, {
    key: "init",
    value: function init(total) {
      if (this.status.tag !== 'new') {
        throw new Error('Monitor already initialized');
      }

      this.total = total;
      this.setWorkingStatus();
    }
  }, {
    key: "setWorkingStatus",
    value: function setWorkingStatus() {
      this._status = {
        tag: 'working',
        total: this.total,
        worked: this.worked,
        cancelable: this.cancellable
      };
    }
  }, {
    key: "progress",
    value: function progress(amount) {
      if (this.status.tag !== 'working') {
        throw new Error('Monitor already not in working state');
      }

      if (amount < 0) {
        amount = 0;
      }

      this.worked += amount;

      if (this.worked > this.total) {
        this.worked = this.total;
      }

      this.setWorkingStatus();
    }
    /**
     * Depending on result of `work` promise either finishes or fails the monitor.
     * @param work
     */

  }, {
    key: "completeWith",
    value: function completeWith(work) {
      var _this2 = this;

      return work.then(function () {
        return _this2.finish();
      }, function (err) {
        return _this2.fail(err);
      });
    }
  }, {
    key: "status",
    get: function get() {
      return this._status;
    }
  }]);

  return Monitor;
}(ProgressMonitor);

var SimpleMonitor =
/*#__PURE__*/
function (_Monitor) {
  _inherits(SimpleMonitor, _Monitor);

  function SimpleMonitor() {
    var _this3;

    _classCallCheck(this, SimpleMonitor);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(SimpleMonitor).apply(this, arguments));
    _this3._canceled = false;
    return _this3;
  }

  _createClass(SimpleMonitor, [{
    key: "wasCanceled",
    value: function wasCanceled() {
      return Promise.resolve(this._canceled);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this._canceled = true;
    }
  }, {
    key: "cancellable",
    get: function get() {
      return true;
    }
  }, {
    key: "canceled",
    get: function get() {
      return this._canceled;
    }
  }]);

  return SimpleMonitor;
}(Monitor);

var LoggingMonitor =
/*#__PURE__*/
function (_SimpleMonitor) {
  _inherits(LoggingMonitor, _SimpleMonitor);

  function LoggingMonitor(log) {
    var _this4;

    _classCallCheck(this, LoggingMonitor);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(LoggingMonitor).call(this));
    _this4.log = log;
    return _this4;
  }

  _createClass(LoggingMonitor, [{
    key: "fail",
    value: function fail(err) {
      var _this5 = this;

      return _get(_getPrototypeOf(LoggingMonitor.prototype), "fail", this).call(this, err).then(function () {
        return _this5.log(_this5.status);
      });
    }
  }, {
    key: "finish",
    value: function finish() {
      var _this6 = this;

      return _get(_getPrototypeOf(LoggingMonitor.prototype), "finish", this).call(this).then(function () {
        return _this6.log(_this6.status);
      });
    }
  }, {
    key: "init",
    value: function init(total) {
      _get(_getPrototypeOf(LoggingMonitor.prototype), "init", this).call(this, total);

      this.log(this.status);
    }
  }, {
    key: "progress",
    value: function progress(amount) {
      _get(_getPrototypeOf(LoggingMonitor.prototype), "progress", this).call(this, amount);

      this.log(this.status);
    }
  }]);

  return LoggingMonitor;
}(SimpleMonitor);

var SubMonitor =
/*#__PURE__*/
function (_Monitor2) {
  _inherits(SubMonitor, _Monitor2);

  function SubMonitor(main, target, _cancellable) {
    var _this7;

    _classCallCheck(this, SubMonitor);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(SubMonitor).call(this));
    _this7.main = main;
    _this7.target = target;
    _this7._cancellable = _cancellable;
    return _this7;
  }

  _createClass(SubMonitor, [{
    key: "fail",
    value: function fail(err) {
      var _this8 = this;

      return _get(_getPrototypeOf(SubMonitor.prototype), "fail", this).call(this, err).then(function () {
        return _this8.main.fail(err);
      });
    }
  }, {
    key: "finish",
    value: function finish() {
      var _this9 = this;

      return _get(_getPrototypeOf(SubMonitor.prototype), "finish", this).call(this).then(function () {
        var rem = _this9.total - _this9.worked;

        _this9.main.progress(_this9.total ? _this9.target * (rem / _this9.total) : _this9.target);
      });
    }
  }, {
    key: "progress",
    value: function progress(amount) {
      var a = this.worked;

      _get(_getPrototypeOf(SubMonitor.prototype), "progress", this).call(this, amount);

      a = this.worked - a;
      this.main.progress(this.total ? this.target * (a / this.total) : 0);
    }
  }, {
    key: "wasCanceled",
    value: function wasCanceled() {
      return this.main.wasCanceled();
    }
  }, {
    key: "cancellable",
    get: function get() {
      return this._cancellable;
    }
  }, {
    key: "canceled",
    get: function get() {
      return this.main.canceled;
    }
  }, {
    key: "status",
    get: function get() {
      return this._status;
    }
  }]);

  return SubMonitor;
}(Monitor);